import { render, staticRenderFns } from "./ChopBox.vue?vue&type=template&id=0f3abeca&scoped=true&"
import script from "./ChopBox.vue?vue&type=script&lang=js&"
export * from "./ChopBox.vue?vue&type=script&lang=js&"
import style0 from "./ChopBox.vue?vue&type=style&index=0&id=0f3abeca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3abeca",
  null
  
)

export default component.exports